module.exports = __webpack_public_path__ + "img/10bLogo.8f433ec4.svg";